module.exports = __webpack_public_path__ + "files/7888b93ffc9c81b9df4809f9f31cc762.png";